<template>
  <public-layout>
    <h1 slot="heading" class="h2 mb-3">Judges</h1>
    <div slot="content" class="public-judges">
      <div class="alert alert-warning" v-if="error">{{error}}</div>

      <h3>Call First List</h3>
      <data-table :dataRows="callFirstJudges" :dataColumns="columns" :options="options">
        <tableTextTemplate slot-scope="{ row }" class="js-parity" :data-parity="row.parity" slot="expandedHeader" :text="row.first_name + ' ' + row.last_name" :link="'Member Profile'" :slug="row.id" :row="row"/>
        <div slot-scope="{ row }" slot="expandedRow" class="js-parity" :data-parity="row.parity">
          <ul class="list-unstyled mb-0 pt-2">
            <li>
              <strong>Status: </strong>
              <tableTextTemplate :text="row.status.charAt(0).toUpperCase() + row.status.substring(1)" :row="row" :options="{ inline: true }"/>
            </li>
            <li>
              <strong>Contact: </strong>
              <tableTextTemplate :text="row.phone" :row="row" :mobile="row.phone" :options="{ inline: true, isMobile: true }" />
            </li>
            <li>
              <strong>Suburb: </strong>
              <tableTextTemplate :text="row.suburb" :row="row" :options="{ inline: true }"/>
            </li>
            <li>
              <strong>Zone: </strong>
              <tableTextTemplate :text="$store.state.listZones.filter(zone => zone.id === row.zone_id).length > 0 ? $store.state.listZones.filter(zone => zone.id === row.zone_id)[0].code : 'Unspecified'" :row="row" :options="{ inline: true }" />
            </li>
          </ul>
        </div>
      </data-table>

      <h3 class="mt-4">Entire ACA Judges Panel</h3>
      <data-table :dataRows="entireJudges" :dataColumns="columns" :options="options" id="entireAacJudgesPanel">
        <tableTextTemplate slot-scope="{ row }" class="js-parity" :data-parity="row.parity" slot="expandedHeader" :text="row.first_name + ' ' + row.last_name" :link="'Member Profile'" :slug="row.id" :row="row"/>
        <div slot-scope="{ row }" slot="expandedRow" >
          <ul class="list-unstyled mb-0 pt-2">
            <li>
              <strong>Status: </strong>
              <tableTextTemplate :text="row.status.charAt(0).toUpperCase() + row.status.substring(1)" :row="row" :options="{ inline: true }"/>
            </li>
            <li>
              <strong>Contact: </strong>
              <tableTextTemplate :text="row.phone" :row="row" :mobile="row.phone" :options="{ inline: true, isMobile: true }" />
            </li>
            <li>
              <strong>Suburb: </strong>
              <tableTextTemplate :text="row.suburb" :row="row" :options="{ inline: true }"/>
            </li>
            <li>
              <strong>Zone: </strong>
              <tableTextTemplate :text="$store.state.listZones.filter(zone => zone.id === row.zone_id).length > 0 ? $store.state.listZones.filter(zone => zone.id === row.zone_id)[0].code : 'Unspecified'" :row="row" :options="{ inline: true }" />
            </li>
          </ul>
        </div>
      </data-table>
    </div>
  </public-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */

import axios from 'axios'
import PublicLayout from "@/components/PublicLayout"
import dataTable from '@/components/DataTable'
import tableTextTemplate from '@/components/DataTableFields/Text'

export default {
  name: 'Judges',
  components: {
    'public-layout': PublicLayout,
    'data-table': dataTable,
    tableTextTemplate
  },
  data() {
    return {
      error: '',
      rows: [],
      entireJudges: [],
      callFirstJudges: [],
      columns: [
        {
          label: 'First Name',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.first_name" :slug="row.id" :row="row"/>`
          }),
          representedAs(row) { return `${row.first_name}` }
        },
        {
          label: 'Last Name',
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.last_name" :slug="row.id" :row="row"/>`
          }),
          representedAs(row) { return `${row.last_name}` }
        },
        {
          label: 'Status',
          field: 'status',
          filterable: false,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.status.charAt(0).toUpperCase() + row.status.substring(1)" :row="row"/>`
          }),
          representedAs: 'status'
        },
        {
          label: 'Contact',
          field: 'phone',
          filterable: false,
          sortable: false,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.phone" :row="row" :mobile="row.phone" :options="{ isMobile: true }" />`
          }),
          representedAs: 'phone'
        },
        {
          label: 'Suburb',
          field: 'suburb',
          filterable: false,
          sortable: false,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate :text="row.suburb" :row="row"/>`
          }),
          representedAs: 'suburb'
        },
        {
          label: 'Zone',
          field: 'zone_id',
          filterable: false,
          sortable: true,
          headerClass: 'd-none d-lg-table-cell',
          visible: true,
          component: ({
            props: ['row'],
            components: { tableTextTemplate },
            template: `<tableTextTemplate class="js-parity" :data-parity="row.parity" :text="rowZone(row.zone_id)" :row="row" />`,
            methods: {
              rowZone(theID) {
                return this.$store.state.listZones.filter(zone => zone.id === theID).length ? this.$store.state.listZones.find(zone => zone.id === theID).code : 'Unspecified'
              }
            }
          })
        }
      ],
      options: {
        filter: {},
        activeFilter: {},
        search: true,
        loaded: false,
        groupByZone: true,
        searchOnAllTables: true
      }
    }
  },
  computed: {
    listZones() {
      return this.$store.state.listZones
    }
  },
  watch: {
    listZones() {
      if (this.listZones.length > 0) {
        this.rows.map((item) => {
          const tempItem = item
          tempItem.zone_name = this.listZones.filter(zone => zone.id === tempItem.zone_id).length > 0 ? this.listZones.filter(zone => zone.id === tempItem.zone_id)[0].code : 'Unspecified'
          return tempItem
        })
      }
    }
  },
  mounted() {
    axios.get(`${this.$api}/judges-list`).then((response) => {
      if (response.data.status === 'success') {
        this.error = ''
        const entireJudges = response.data.data.entire
        const callFirstJudges = response.data.data.is_call_first
        if (this.listZones.length > 0) {
          entireJudges.map((item) => {
            const tempItem = item
            tempItem.zone_name = this.listZones.filter(zone => zone.id === tempItem.zone_id).length > 0 ? this.listZones.filter(zone => zone.id === tempItem.zone_id)[0].code : 'Unspecified'
            return tempItem
          })
        }
        this.entireJudges = entireJudges
        this.callFirstJudges = callFirstJudges
        this.options.loaded = true
      } else {
        this.error = 'Unable to receive data from the server. Please reload the page.'
      }
    })
  },
  methods: {
    colorTableFields() {
      // eslint-disable-next-line
      let tables = document.querySelectorAll('tbody')
      tables.forEach((table) => {
        const cellsHtmlCollection = table.getElementsByTagName('tr')
        const cells = this.htmlCollectionToArray(cellsHtmlCollection)
        cells.forEach((cell) => {
          const parity = cell.querySelector('.js-parity')?.dataset?.parity
          if (!parity) {
            return
          }
          if (parity === 'even') {
            cell.classList.add('row-odd')
          } else {
            cell.classList.add('row-even')
          }
        })
      })
    },
    htmlCollectionToArray(htmlCollection) {
      const array = []
      for (let i = 0; i < htmlCollection.length; i++) {
        array.push(htmlCollection[i])
      }
      return array
    }
  },
  updated() {
    this.colorTableFields()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Judges/Listing/Judges.vue